<template>
	<v-slide-x-transition>
		<div class="left-side-drawer display-flex flex-2" :class="sideBarClasses" v-if="isLeftSideDrawerOpen">
			<SetupEditorPanel class="height-100 width-100" :hasEditPermissions="hasEditPermissions" @closeSideBar="$emit('closeSideBar')" />
		</div>
		<template v-else>
			<router-view :workflowId="workflowId" @close="closeDrawer" v-on="$listeners" class="debug-mode" name="task-log" />
			<router-view
				name="version"
				v-on="$listeners"
				@close="closeDrawer"
				:versionId="versionId"
				class="version-history"
				:workflowId="workflowId"
			/>
		</template>
	</v-slide-x-transition>
</template>

<script>
import { isLeftSideDrawerOpen, isLeftDrawerTestMode, isLeftDrawerEditMode } from '@/store/modules/leftSideDrawer/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import SetupEditorPanel from '@/views/Flow/SetupEditorPanel.vue';

export default {
	name: 'LeftSideDrawer',
	props: {
		versionId: { type: Number },
		workflowId: { type: Number },
		hasEditPermissions: { type: Boolean },
	},
	components: {
		SetupEditorPanel,
	},
	computed: {
		...mapGettersShorthand({ isLeftSideDrawerOpen, isLeftDrawerTestMode, isLeftDrawerEditMode }),
		sideBarClasses() {
			return [
				{
					'is-open': this.isLeftSideDrawerOpen,
					'is-test-mode': this.isLeftDrawerTestMode,
					'is-edit-mode': this.isLeftDrawerEditMode,
				},
			];
		},
	},
	methods: {
		closeDrawer() {
			this.$emit('closeSideBar');
		},
	},
};
</script>

<style scoped lang="scss">
.left-side-drawer {
	transition: all 0.3s !important;
	transform: translateX(-100%) !important;
	background: var(--bg-color) !important;
	box-shadow: 0px 3px 6px rgb(0 0 0 / 20%) !important;
	z-index: $z-index-drawer;

	&.is-test-mode {
		max-width: 583px;
		min-width: 583px;
	}

	&.is-edit-mode {
		max-width: 1022px;
		min-width: 1022px;
	}

	&.is-open {
		transform: translateX(0) !important;
	}
}
.debug-mode {
	max-width: $builder-task-log-width;
	min-width: $builder-task-log-width;
}
.version-history {
	max-width: $builder-version-history-width;
	min-width: $builder-version-history-width;
}
</style>
